import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TemplateModel } from '@fi-app/template/template.model';
import { BaseItemModelService } from '@fi-app/template/base-item.model';

@Component({
    selector: 'fi-document-template-item-options-column',
    template: '<ng-container *ngComponentOutlet="item.optionComponent"></ng-container>',
    standalone: false,
})
export class FiDocumentTemplateItemOptionsColumnComponent {
    @Input() item: BaseItemModelService;
    @Input() column: number;
    @Input() content;
    @Input() template: TemplateModel;

    @Output('mediaBankFileChanged') mediaBankFileChangedEmitter = new EventEmitter<any>();
}
